import { render, staticRenderFns } from "./shop-product.vue?vue&type=template&id=665e1cc2&scoped=true"
import script from "./shop-product.vue?vue&type=script&lang=js"
export * from "./shop-product.vue?vue&type=script&lang=js"
import style0 from "./shop-product.vue?vue&type=style&index=0&id=665e1cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e1cc2",
  null
  
)

export default component.exports